import SupportRequestsPage from '../pages/SupportRequestsPage.vue'
import SupportRequestPage from '../pages/SupportRequestPage.vue'
import HolidaysPublicLayout from '../components/layouts/HolidaysPublicLayout.vue'
import HolidaysPublicAdminPage from '../pages/HolidaysPublicAdminPage.vue'
import HolidaysPublicCompanyUsersPage from '../pages/HolidaysPublicCompanyUsersPage.vue'
import HolidaysPublicIndexPage from '../pages/HolidaysPublicIndexPage.vue'
import HolidaysPublicUserCompaniesPage from '../pages/HolidaysPublicUserCompaniesPage.vue'
import HolidaysPublicCompanyPage from '../pages/HolidaysPublicCompanyPage.vue'

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    path: '/holiday-schedules/companies/:companyUuid',
    name: 'HolidaysPublicCompanyPage',
    component: HolidaysPublicCompanyPage,
    meta: { requiresAuth: true, title: 'holidaysPublic.nav.company', layout: 'Authenticated' },
  },
  {
    path: '/holiday-schedules/companies/:companyUuid/holidays',
    name: 'CompanyHolidaysPage',
    component: HolidaysPublicIndexPage,
    meta: { requiresAuth: true, title: 'holidaysPublic.nav.holidays', layout: 'Authenticated' },
  },
  {
    path: '/holiday-schedules/support-requests',
    name: 'SupportRequestsPage',
    component: SupportRequestsPage,
    meta: { requiresAuth: true, title: 'holidaysPublic.nav.supportRequests', layout: 'Authenticated' },
  },
  {
    path: '/holiday-schedules/companies/:companyUuid/support-requests',
    name: 'CompanySupportRequestsPage',
    component: SupportRequestsPage,
    meta: { requiresAuth: true, title: 'holidaysPublic.nav.supportRequests', layout: 'Authenticated' },
  },
  {
    path: '/holiday-schedules/support-requests/:supportRequestId',
    name: 'SupportRequestPage',
    component: SupportRequestPage,
    meta: { requiresAuth: true, title: 'holidaysPublic.nav.supportRequests', layout: 'Authenticated' },
  },
  {
    path: '/holiday-schedules/my-companies',
    name: 'HolidaysPublicUserCompaniesPage',
    component: HolidaysPublicUserCompaniesPage,
    meta: {
      requiresAuth: true,
      title: 'holidaysPublic.nav.myCompanies',
      layout: 'Authenticated',
    },
  },
  {
    path: '/holiday-schedules',
    name: 'HolidaysPublicAdminPage',
    component: HolidaysPublicAdminPage,
    meta: {
      requiresAuth: true,
      permission: 'holidays public administer',
      title: 'holidaysPublic.nav.manage',
      layout: 'Authenticated',
    },
  },
  {
    path: '/holiday-schedules/company-users',
    name: 'HolidaysPublicCompanyUsersPage',
    component: HolidaysPublicCompanyUsersPage,
    meta: {
      requiresAuth: true,
      permission: 'holidays public administer',
      title: 'holidaysPublic.nav.companyUsers',
      layout: 'Authenticated',
    },
  },
  {
    path: '/holidays/:companyUuid',
    name: 'holidays-public.root',
    component: HolidaysPublicLayout,
    meta: {
      title: 'holidaysPublic.nav.title',
      layout: 'Guest',
    },
    children: [
      {
        path: '',
        name: 'HolidaysPublicIndexPage',
        component: HolidaysPublicIndexPage,
      },
    ],
  },
  {
    path: '/customer-accounts/:companyUuid/upcoming-holidays',
    redirect: route => ({ name: 'HolidaysPublicIndexPage', params: { companyUuid: route.params.companyUuid } }),
  },
]
